import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getTwitterSettings = ({
  twitterUsername
}: Partial<ChatsChannelBase>) => {
  if (!twitterUsername) return null;

  const url = `https://twitter.com/${twitterUsername}`;

  return {
    provider: ChatsChannelType.twitter,
    link: { url },
    title: 'X',
    icon: getChatIcon(ChatsChannelType.twitter),
    color: 'rgb(0, 0, 0)'
  } as ChatsChannelSetting;
};
